/**
 * 文字列を最大 maxLength 文字に切り詰め、超過時は末尾に「…」を付与する。
 */
export function truncateText(text: string | null | undefined, maxLength = 10): string {
  if (!text) return '';
  return text.length > maxLength ? `${text.slice(0, maxLength)}…` : text;
}
